import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import moment from "moment";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Menu,
  Dropdown,
} from "antd";
import { Document1 } from "./ReportDocuments/Document_1";
import { Document2 } from "./ReportDocuments/Document_2";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import { roleAction } from "../../_actions/roleby.action";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
//import { Reports1 } from "./Tables/Tabel1";
const Reports1 = React.lazy(() =>
  import("./Tables/Tabel1").then((module) => ({
    default: module.Reports1,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class Reports extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_3_startDate: "",
    report_3_endDate: "",
    report_1_startDate: "",
    report_1_endDate: "",
    report1_loader: false,
    report3_loader: false,
    report1_List: [],
    report1_List_Total: null,
    report1_API_loader: false,
    report1_Total: null,
    download: "excel",
  };

  componentDidUpdate() {
    // const { authentication } = this.props;
    // if(authentication && authentication.user && authentication.user.role==='2'){
    //   return <Redirect to='/login'  />
    // }
  }

  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
  }

  generatePDFDocument = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_3_startDate,
      endDate: this.state.report_3_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report3_loader: true,
    });
    professionalAction.getReport3(obj).then((res) => {
      res &&
        res.text().then(async (text) => {
          const tempData = _.flatten(text && JSON.parse(text));
          const tempFilterData = _.filter(tempData, function (o) {
            return Object.keys(o).length !== 0;
          });
          const blob = await pdf(
            <Document1 rows={tempFilterData} filterDate={obj} />,
          ).toBlob();
          this.setState({
            report3_loader: false,
          });
          saveAs(blob, "पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल");
        });
    });
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_1_startDate,
      endDate: this.state.report_1_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report1_loader: true,
    });
    const blob = await pdf(
      <Document2
        rows={this.state.report1_List}
        filterDate={obj}
        total={this.state.report1_List_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report1_loader: false,
      });
      saveAs(blob, "आरोपी सांख्यिकी अहवाल.pdf");
    }
  };

  download_csv = () => {
    const { t } = this.context;
    var ReportTitle = t("accused_statistical_report");
    var title = t("accused_statistical_report");
    var arrData1 = this.state.report1_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      arrData1?.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("police_station")]: data.policeThane,
        [t("accused_within_jurisdiction")]: data.totalCriminals,
        [t("final_report_count")]: data.totalInactiveCriminals,
        [t("data_entered_by_police_station1")]: data.allTotalCriminalsbyUser,
      })) || [];

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `${moment(this.state.report_1_startDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    if (user && user.role === "4") {
      let obj = {
        startDate: this.state.report_1_startDate,
        endDate: this.state.report_1_endDate,
        cityId: user && user.cityId,
      };

      professionalAction.getReport1(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data,
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            this.setState({
              report1_API_loader: false,
              report1_List: tempFilterData,
              report1_List_Total: tempData && tempData.allTotalCriminals,
              report1_Total: tempData && tempData.totalCriminals,
            });
          });
      });
    }
    if ((user && user.role === "9") || (user && user.role === "10")) {
      let obj = {
        startDate: this.state.report_1_startDate,
        endDate: this.state.report_1_endDate,
        districtId: user && user.map_districtId,
      };

      roleAction.getStatisticalReport(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data,
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            this.setState({
              report1_API_loader: false,
              report1_List: tempFilterData,
              report1_List_Total: tempData && tempData.allTotalCriminals,
              report1_Total: tempData && tempData.totalCriminals,
            });
          });
      });
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  onFinishDateRangeGPSTable = (values) => {
    if (values) {
      this.setState({
        report_3_startDate: values.toISOString(),
      });
    }
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      this.setState({
        report_1_startDate: values.toISOString(),
      });
    }
  };

  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report1_List;

    return (
      arrData1?.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("police_station")]: data.policeThane,
        [t("accused_within_jurisdiction")]: data.totalCriminals,
        [t("final_report_count")]: data.totalInactiveCriminals,
        [t("data_entered_by_police_station1")]: data.allTotalCriminalsbyUser,
      })) || []
    );
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("accused_statistical_report");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(this.state.report_1_startDate),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };
  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report1_List } = this.state;

    const sortedData = [...report1_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report1_List: sortedData });
  };
  navigateToAropiCount = () => {
    this.props.history.push("/aropi-count");
  };
  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;
    const { language, t } = this.context;
    const { key, direction } = this.state;

    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="totalCriminals">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            हद्दीतील एकूण आरोपी
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "totalCriminals" && direction === "ASC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("totalCriminals", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "totalCriminals" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("totalCriminals", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
        <Menu.Item key="totalInactiveCriminals">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            निक्षिप्त रिपोर्ट गणना
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "totalInactiveCriminals" && direction === "ASC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("totalInactiveCriminals", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "totalInactiveCriminals" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("totalInactiveCriminals", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
        <Menu.Item key="allTotalCriminalsbyUser">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            पो. स्टे. नी भरलेली माहिती
            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "allTotalCriminalsbyUser" && direction === "ASC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("allTotalCriminalsbyUser", "ASC")} // Toggle to ASC
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "allTotalCriminalsbyUser" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("allTotalCriminalsbyUser", "DESC")} // Toggle to DESC
            />
          </div>
        </Menu.Item>
      </Menu>
    );
    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-12">
          <div
            style={{
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              background: "#fff",
              border: "1px solid #f0f0f0",
            }}
          >
            {/* Title Section */}
            <div
              style={{
                padding: "16px 20px",
                borderRadius: "8px 8px 0 0",
                background: "#fff",
                marginBottom: "0",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#262626",
                }}
              >
                {t("accused_statistical_report")}
              </h2>
            </div>

            {/* Filter Row with Find/Download Options */}
            <div
              className="border-none box-none filter-row "
              style={{
                padding: "16px 20px",
                borderRadius: "0 0 8px 8px",
                background: "#fff",
                marginBottom: "0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                className="button-group-responsive"
              >
                {/* Left Side - Date Picker and Find Button */}
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Date Picker */}
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      flex: "0 0 auto",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#262626",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {t("select_date")}:
                    </span>
                    <DatePicker
                      onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                      inputReadOnly
                      placeholder={t("select_date")}
                      style={{ width: "150px" }}
                      format={"DD/MM/YYYY"}
                    />
                  </div>

                  {/* Find Button */}
                  <Button
                    type="primary"
                    disabled={!this.state.report_1_startDate}
                    onClick={this.generatePDFReport1}
                    className="modern-button modern-button-success"
                    style={{ minWidth: "100px" }}
                  >
                    {t("find")}
                  </Button>
                </div>

                {/* Right Side - Download Section */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    flex: "0 0 auto",
                  }}
                >
                  <div className="download-section-responsive margin-0">
                    <div className="download-group-responsive">
                      <Space
                        direction="horizontal"
                        size="middle"
                        className="download-space-responsive"
                      >
                        <Form>
                          <Form.Item
                            name="condition"
                            rules={[
                              {
                                required: true,
                                message: "Please select a value",
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <Select
                              defaultValue={this.state.download}
                              placeholder={t("please_select_an_option")}
                              value={this.state.download}
                              onChange={(value) =>
                                this.setState({ download: value })
                              }
                              className="download-select-responsive"
                              disabled={!this.state.report1_List.length}
                              style={{ width: "120px" }}
                            >
                              <Option key="excel" value="excel">
                                {t("excel")}
                              </Option>
                              <Option key="pdf" value="pdf">
                                PDF
                              </Option>
                            </Select>
                          </Form.Item>
                        </Form>

                        {this.state.download && (
                          <Button
                            type="primary"
                            className="download-button-responsive download-button-success"
                            onClick={() => this.downloadReport()}
                            disabled={!this.state.report1_List.length}
                            style={{ minWidth: "100px" }}
                          >
                            {t("download")}
                          </Button>
                        )}
                      </Space>
                    </div>
                  </div>
                </div>
                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  arrow
                  disabled={!this.state.report1_List?.length}
                >
                  <Button type="ghost">
                    {t("sorter_by")} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
              <Button
              
              type="primary"
              onClick={() => this.navigateToAropiCount()}>आरोपी सांखिकी (वर्षनिहाय)</Button>
            </div>
          </div>
          {/* Reports Table */}
          <React.Suspense fallback={<div>Loading...</div>}>
            <Reports1
              data={this.state.report1_List}
              totalAll={this.state.report1_Total}
              total={this.state.report1_List_Total}
              userRole={user && user.role}
              loading={this.state.report1_API_loader}
            />
          </React.Suspense>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReports = connect(mapStateToProps)(Reports);
export { connectedReports as Reports };
